(() => {
  const selectors = {
    quotesSlider: '.js-quotes-slider',
    quotesSliderSwiper: '.js-quotes-slider .swiper',
    quotesSliderSlide: '.quotes-slider__slide-text',
    logoSlides: '.quotes-slider__slide'
  }

  const quotesSliderElement = document.querySelector(selectors.quotesSlider);
  if (!quotesSliderElement) return;

  const slidesCount = parseInt(quotesSliderElement.dataset.slidesCount) || 0;
  const slides = quotesSliderElement.querySelectorAll(selectors.quotesSliderSlide);
  const logoSlides = quotesSliderElement.parentElement.querySelectorAll(selectors.logoSlides);
  const logoSliderContainer = quotesSliderElement.parentElement.querySelector('.quotes-logo-slider');
  
  if (slidesCount <= 1 || slides.length <= 1) {
    quotesSliderElement.classList.add('quotes-slider--single-slide');
    return;
  }

  const { autoplay, delay, loop, pause_on_hover } = quotesSliderElement.dataset;

  const scrollToActiveLogo = (activeIndex) => {
    if (!logoSliderContainer || !logoSlides[activeIndex]) return;
    
    const activeLogo = logoSlides[activeIndex];
    const containerRect = logoSliderContainer.getBoundingClientRect();
    const logoRect = activeLogo.getBoundingClientRect();
    
    const isFullyVisible = 
      logoRect.left >= containerRect.left && 
      logoRect.right <= containerRect.right;
    
    if (!isFullyVisible) {
      const scrollLeft = activeLogo.offsetLeft - (containerRect.width / 2) + (logoRect.width / 2);
      
      logoSliderContainer.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  };

  const quotesSliderSwiper = new Swiper(selectors.quotesSliderSwiper, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 250,
    autoplay: autoplay ===  'true' ? {
      enabled: true,
      delay: parseInt(delay) || 4000,
      disableOnInteraction: true,
      pauseOnMouseEnter: pause_on_hover === 'true'
    } : false,
    loop: loop === 'true',
    on: {
      slideChange: function () {
        logoSlides.forEach((logo, index) => {
          logo.classList.remove('active');
        });
        
        const activeIndex = this.realIndex;
        if (logoSlides[activeIndex]) {
          logoSlides[activeIndex].classList.add('active');
          scrollToActiveLogo(activeIndex);
        }
      },
      init: function () {
        if (logoSlides[0]) {
          logoSlides[0].classList.add('active');
          scrollToActiveLogo(0);
        }
      }
    }
  });

  logoSlides.forEach((logo, index) => {
    logo.addEventListener('click', () => {
      if (loop === 'true') {
        quotesSliderSwiper.slideToLoop(index);
      } else {
        quotesSliderSwiper.slideTo(index);
      }
      
      if (quotesSliderSwiper.autoplay && quotesSliderSwiper.autoplay.running) {
        quotesSliderSwiper.autoplay.stop();
        setTimeout(() => {
          quotesSliderSwiper.autoplay.start();
        }, 2000);
      }
    });
  });
})();